
// Clients
export {default as AddEditClientPage} from './AddEditClientPage';

// Entries
export {default as AddEditEntryPage} from './AddEditEntryPage';

// Projects
export {default as AddEditProjectPage} from './AddEditProjectPage';
export {default as ReportingPage} from './ReportingPage';
export {default as ProjectPage} from './ProjectPage';
export {default as ProjectsPage} from './ProjectsPage';

// Tasks
export {default as TasksPage} from './TasksPage';

// Authentication
export {default as SignInPage} from './SignInPage';

// Users
export {default as UserPage} from './UserPage'

// Admin
export {default as TeamPage} from './TeamPage'
export {default as AddTeamMemberPage} from './AddTeamMemberPage'
export {default as UpgradePage} from './UpgradePage'

// Other
export {default as FeedbackPage} from './FeedbackPage'
export {default as CancelPage} from './CancelPage'

// Public
export {default as PublicWebsitePage} from './PublicWebsitePage';
export {default as TeamInvitePage} from './TeamInvitePage';
export {default as NewTeamPage} from './NewTeamPage';
export {default as ErrorPage} from './ErrorPage';

//Test
export {default as TestPage} from './TestPage';


// WEBPACK FOOTER //
// ./src/pages/index.js